import * as React from "react";
import {
  Text,
  View,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  Platform,
  Linking
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { Ionicons } from "@expo/vector-icons";
import Colors from "../../utilities/Color.js";

export default function FogotLoginScreen() {
  const navigation = useNavigation();
  return (
    <View style={GlobalStyles.containerMB}>
      <ScrollView>
        <View style={GlobalStyles.bodyContainerT}>
          <View style={styles.HbuttonBar}>
            <TouchableOpacity
              style={styles.HbackButtonStyle}
              onPress={() => navigation.goBack()}
            >
              <Ionicons
                name="md-arrow-back"
                size={20}
                color={Colors.WHITE}
              />
            </TouchableOpacity>
          <View>
            <Text style={styles.HTextStyle}>FORGOT LOGIN</Text>
          </View>
          <View style={styles.HbackButtonStyle}></View>
          </View>
          <View style={styles.container}>
            <Text style={styles.TextStyleLink}>Forgot your login?</Text>
            <Text style={[styles.TextStyleLink, { fontFamily: 'montserrat-medium' }]}>Use the ‘Forgot password’ option. Enter the email or phone number you registered with to receive a reset code.</Text>
            <Text style={[styles.TextStyleLink, { fontFamily: 'montserrat-medium' }]}>
              Or contact our&nbsp;
              <Text style={[{ textDecorationLine: 'underline' }]}
                onPress={() => {
                  Platform.OS !== "web"
                    ? Linking.openURL("https://aura.club/contact/")
                    : window.open("https://aura.club/contact/", "_blank");
                }}>support team
              </Text>
              <Text>
              </Text> with your details and we will be in touch.
            </Text>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    marginLeft: 30,
    marginRight: 30,
    maxWidth: 480,
    alignSelf: "center"
  },
  TextStyleLink: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    paddingTop: 10,
    lineHeight: 20
  },
  HbuttonBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    marginTop: 25,
  },
  HbackButtonStyle: {
    marginTop: 5,
    paddingTop: 5,
    paddingBottom: 5,
    width: 75,
  },
  HTextStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  }
});
